<script>
import api from '@/helpers/api'
export default {
  name: 'translation-form-dialog.app',
  props: {
    visible: { type: Boolean, default: false },
    id: { type: String },
    locale: { type: String }
  },
  data: () => ({
    translation: {},
    isLoading: false
  }),
  methods: {
    reset () {
      this.translation = {
        is_active: true
      }
    },
    onCancel () {
      this.$emit('update:visible', false)

      this.$nextTick(() => {
        this.reset()
      })
    },
    async init () {
      if (this.isUpdate) {
        let item = await api.i18NTranslation.fetch({
          key: this.id,
          locale: this.locale
        })

        this.translation = { ...item }
      } else this.reset()
    },
    async onSave () {
      let valid = true

      if (valid) {
        try {
          let item
          this.isLoading = true
          let successTitle
          if (this.isUpdate) {
            successTitle = `Translation '${this.translation.key}' was updated!`
            item = await api.i18NTranslation.update({
              ...this.translation,
              key: this.id,
              locale: this.locale
            })
          } else {
            successTitle = `Translation '${this.translation.key}' was added!`
            item = await api.i18NTranslation.create({
              ...this.translation
            })
          }
          this.$bvToast.toast(successTitle, {
            title: 'Translation Added',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false

          this.$emit('created', item)
          this.onCancel()
        } catch (err) {
          this.$bvToast.toast(`${err}!`, {
            title: 'Error',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false
        }
      }
    }
  },
  watch: {
    visible: {
      handler (v) {
        if (v) this.init()
      }
    }
  },
  computed: {
    isUpdate () {
      return !!this.id
    },
    title () {
      return this.isUpdate ? 'Edit Translation' : 'New Translation'
    },
    saveBtnLabel () {
      return this.isUpdate ? 'Save Changes' : 'Create Translation'
    }
  }
}
</script>
<template>
  <b-modal
    v-model="visible"
    :title="title"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    size="md"
  >
    <b-form-group label="Key" label-for="translation_key" label-cols-sm="3">
      <b-form-input
        id="translation_key"
        v-model="translation.key"
        type="text"
        required
        autocomplete="translation_key"
        placeholder="Unique Key"
        :style="{ maxWidth: '350px' }"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label="Translation"
      label-for="translation_translation"
      label-cols-sm="3"
    >
      <b-form-input
        id="translation_translation"
        v-model="translation.translation"
        type="text"
        required
        autocomplete="translation_translation"
        placeholder="Translation"
        :style="{ maxWidth: '350px' }"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-for="locale"
      label-cols-sm="3"
      class="d-flex align-items-center"
    >
      <template v-slot:label>
        <div class="d-flex align-items-center pointer">
          Language
        </div>
      </template>
      <app-language-select id="locale" v-model="translation.locale" />
    </b-form-group>

    <template v-slot:modal-footer>
      <div class="d-flex justify-content-end" style="width: 100%">
        <div>
          <b-button variant="link" @click="onCancel" class="mr-2"
            >Cancel</b-button
          >
          <b-btn variant="primary" class="btn-label" @click="onSave">
            <i class="bx bxs-save label-icon"></i>
            {{ saveBtnLabel }}
          </b-btn>
        </div>
      </div>
    </template>
  </b-modal>
</template>
